import { api } from './client';

export interface ChannelRow {
  period?: string;
  channel: string;
  spend: number;
  impressions: number;
  reach: number;
  reach_supported?: boolean;
  frequency: number;
  clicks: number;
  add_to_cart: number;
  purchases: number;
  revenue: number;
  registrations: number;
  cpm: number;
  ctr: number;
  cpc: number;
  add_to_cart_cost: number;
  cpa: number;
  roi: number;
  aov: number;
  add_to_cart_rate: number;
  cart_conversion_rate: number;
  purchase_rate: number;

  paid_user_num: number;
  order_num: number;
  new_base_payable: number;
  new_order_num: number;
  new_user_num: number;
  new_user_rate: number;
  new_aov: number;
  new_arpu: number;
  first_order_payable: number;
  first_order_order_num: number;
  first_order_aov: number;
}

export interface AllViewsResponse {
  channel_summary: ChannelRow[];
  channel_upper: ChannelRow[];
  channel_middle: ChannelRow[];
  channel_lower: ChannelRow[];
  layer_total: ChannelRow[];
  layer_detail: ChannelRow[];
}

export interface ChannelMonitoringParams {
  brand_id: string;
  site_id?: string;
  period_type?: string;
  start_date?: string;
  end_date?: string;
  period_start?: string;
}

export const channelMonitoringApi = {
  getData: (params: ChannelMonitoringParams) =>
    api.get<{ code: number; data: AllViewsResponse }>('/channel-monitoring/data', { params }),
};
